import axios from "axios";
import Cookies from "universal-cookie";

const cookies = new Cookies();
export const getEducationTypeApi = async (url:string) => {
    const token = cookies.get('authToken');
    try {
        const response = await axios.get(
            `${url}/EducationType/GetAllEducationType`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deleteEducationTypeApi = async (id: string, url:string) => {
    const token = cookies.get('authToken');

    try {

        const response = await axios.request({
            method: "DELETE",
            url: `${url}/EducationType/Delete`,
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            data: {
                id,
            },
        });
        return response.data;

    } catch (error) {
        console.error(error)
        throw error;
    }
}


export const addEducationTypeApi = async (
    name: string,
    url:string
) => {
    const token = cookies.get('authToken');
    try {
        const response = await axios.post(
            `${url}/EducationType/create`, {
            name,
        },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        )
        return response.data;
    } catch (error) {
        console.error('API Error', error);
        throw error
    }
}

export const updateEducationTypeApi = async (
    Id: string,
    Name: string,
    url:string
) => {
    const token = cookies.get('authToken');
    try {
        const response = await axios.post(
            `${url}/EducationType/update`, {
            Id,
            Name,
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
        )
        return response.data;
    } catch (error) {
        console.error('API Error', error);
        throw error
    }
}